exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enterprise_logo_wrapper[data-v-7cb1ef12] {\n  width: 150px;\n  height: 150px;\n  position: absolute;\n  top: -220px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  z-index: 10;\n}\n.duration_close[data-v-7cb1ef12] {\n  position: absolute;\n  width: 15.5px;\n  height: 15.5px;\n  display: block;\n  right: -2px;\n  bottom: 35px;\n  z-index: 10;\n  color: #DE3C68;\n}\n.portlet_wrapper[data-v-7cb1ef12] {\n  margin-top: 130px !important;\n}", ""]);

// exports
